import Vue from 'vue'
import Router from 'vue-router'
import login from '@/views/login.vue'

Vue.use(Router)

export default new Router({
  routes: [

    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login'),
    },
    {
      path: '/policy',
      name: 'policy',
      component: () => import('@/views/privacypolicy'),
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js